import { render, staticRenderFns } from "./HomeWelcomeMessage.vue?vue&type=template&id=0514b6a6&scoped=true&"
import script from "./HomeWelcomeMessage.vue?vue&type=script&lang=js&"
export * from "./HomeWelcomeMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0514b6a6",
  null
  
)

export default component.exports